function goProviderDetail(address, ascUrl, ascLatitudeValue, ascLongitudeValue, ascPostalCode, postalCode, repairableCateId, warrantyTypeStatus, dmsFlag){
	var f						= document.repairForm;
    f.action					= ascUrl;			  // Json
    f.dmsFlag.value	            = dmsFlag;            // Json
    f.target                    = "_blank";
    f.method 					= "post";
    f.submit(); 
}

(function() {
    var proto;
    var BaiduMaps = function(el, options) {
        var self = this;

        self.$repairCenter = $(".find-service-center");
        self.$repairSection = self.$repairCenter.find('.repair-map-information');
        self.$repairDetail = self.$repairCenter.find('.repair-informaiton-detail');
        self.$repairStoreList = self.$repairCenter.find("#repairCenterResult");
        self.$repairTabmenu = self.$repairCenter.find('.map-store-distance');
        self.$repairForm = self.$repairCenter.find('#repairForm');
        self.$directionsForm = self.$repairCenter.find('#directionForm');
        self.$repairOrigin = self.$repairCenter.find('#repairOrigin');
        self.$searchInput = self.$repairCenter.find('#serviceCenterZip');
        self.$repairMapArea = self.$repairCenter.find('#repairMap');
        self.$productSelect = self.$repairCenter.find('#repairProduct');
        self.$searchBtn = self.$repairCenter.find('#serviceCenterSubmit');
        self.$expandaleMap = self.$repairCenter.find('.map-expend');
        self.$repairTitle = self.$repairCenter.find('.btn-collapse');
        self.$resultLocation = self.$repairCenter.find('.search-location');
        self.$myAddressBtn = self.$repairCenter.find('#selectAddress');
        
        self._basic();
    };

    // Alias the prototype for less typing and better minification
    proto = BaiduMaps.prototype;
    proto._defaults = {
        country: null,
        zoomLevel: 10,
        zoomLevelMin: 2,
        zoomLevelMax: 24,
        viewport: null,
        countryRestriction: true,
        queryZoomLevel: 16,
        queryUrl: '/lg5-common-gp/data-ajax/support/find-service-center-cn.json',
        queryType: "json",
        unitMetric: false,
        useDirection: false,
        centerLatitude: null,
        centerLongitude: null,
        useController: false,
        debug: false,
        unit: 'Mile', //metric(Km), imperial(Mile),
        distance: 8
    };

    proto._basic = function() {
        var self = this;

        self.options = $.extend({}, self._defaults, self.$repairCenter.data());     
        self.options.unit = self.$repairForm.find("[name=distanceType]").val() == "mi" ? "Mile" : "Km";
        self.options.unit == "Km" && (self.options.unitMetric = true);
        
        self._init();
    }

    proto._init = function() {
        var self = this;

        self.markers = [];
        self.stores = [];
        self.activeItem;
        self.searchHandle = false;
        self.openDirection = false;
        self.afterControl = false;
        self.distance = self.options.distance;
        self.openDirection = self.options.useDirection;
        self.geoResult = {};
        self.timing = {
            queryTimeout: null
        };
        self.markerIcon = {
            size: '', //new google.maps.Size(34, 46),
            anchor: '' //new google.maps.Point(17, 46)
        }
        self.mapSetting(); 
    }
    
    proto.mapSetting = function() {
        var self = this;

        self.mapOptions = {
            zoom: self.options.zoomLevel,
            zoomLevel: self.options.zoomLevel
        }
        
        self.infoOptions = {
            disableAutoPan: true,
            alignBottom: true,
            pixelOffset: {
                "width" : -162,
                "height" : -54
            },
            zIndex: 99,
            boxStyle: {
                width: "320px"
            },
            infoBoxClearance: {
                "width" : 1,
                "height" : 1
            },
            enableEventPropagation: true,
            boxClass: "infoWindow"
        };
        
        self.map = new BMap.Map(self.$repairMapArea[0], self.mapOptions);
        self.map.centerAndZoom(new BMap.Point(116.4035, 39.915), self.options.zoomLevel);
        self.map.enableScrollWheelZoom(true);
        self.map.addEventListener = function(event, fun) {
            if (event == "moveend" || event == "mousemove") {
                return false;
            } else {
                this['on' + event] = fun;
            }
        }
        
        self.infoBox = {
            open: function(markerText, point) {
                var infoWindow = new BMap.InfoWindow(markerText, {width:320});  
                self.map.openInfoWindow(infoWindow, point);
                self.map.setCenter(point);
            },
            close: function() {
                self.map.closeInfoWindow();
            }
        }
        self.mapControl();

        if (!self.openDirection) {
            self.setCountry(self.options.country);
            self.autoZipcode(self.$searchInput[0]);
        } else {
            self.directionResult = document.getElementById('directionResult');
            self.$suggest = $(self.directionResult).find(".suggest");
            self.$repairErrorList =  $(self.directionResult).find(".repair-error-list");
            self.markerCss = {
                origin : {background:"url(http://api0.map.bdimg.com/images/dest_markers.png) no-repeat"},
                destination : {background:"url(http://api0.map.bdimg.com/images/dest_markers.png) no-repeat 0 -34px"}
            }
            // $(self.directionResult).append("<div id='directionResultRoute' style='margin-right:10px;'/>");
            self.autoZipcode(self.$repairOrigin[0]);
            self.reset();
        }
    };

    //autocomplet input
    proto.autoZipcode = function(element) {
        var self = this;
        
        self.autoComplete = new BMap.Autocomplete({
            "input" : element
            ,"location" : self.map
        });
        
        self.autoComplete.addEventListener("onhighlight", function(e) {
            var str = "";
            var _value = e.fromitem.value;
            var value = "";
            if (e.fromitem.index > -1) {
                value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
            }    
            str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;

            value = "";
            if (e.toitem.index > -1) {
                _value = e.toitem.value;
                value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
            }    
            str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
        });
        
        var myValue;
        self.autoComplete.addEventListener("onconfirm", function(e) {
            var _value = e.item.value;
            myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
        });
        
    }

    proto.mapControl = function() {
        var self = this;
        // layer toggle event
        self.$repairTitle.on('click', $.proxy(layerToggleHandler, self));
        self.$expandaleMap.on('click', $.proxy(self.mapExpand, self));
        
        // tab toggle event
        self.$repairTabmenu.find("li a").on('click', $.proxy(self.distanceHandler, self));
  
        // form search submit
        self.$repairForm.on('submit', $.proxy(self.searchAddress, self));
        self.$directionsForm.on('submit', $.proxy(self.setDirectionPanel, self));
        
        // store list click
        self.$repairStoreList.on('click', '.list-anchor', function(e) {
            var $this = $(this),
                item = $this.data('item');

            self.activeItem = item;
            self.setStoreInfo(self.stores, self.infoBox, item);

            if ($(window).width() >= 768) {
                //self.offsetCenter(self.markers[item].getPosition(), 220, -100, self.map);
            } else {
                self.offsetCenter(self.markers[item].getPosition(), 0, -140, self.map);
            }

            self.$repairStoreList.find('.list-box').not($this).removeClass('active');
            $this.addClass('active');

            e.preventDefault();
        });

        // resize event
        $(window).on('resize', function() {
            var $windowWidth = $(window).width();
            
            if ($windowWidth < 768) {
                if (!self.$repairStoreList.hasClass('slick-initialized')) self.slickEvent(self.$repairStoreList, true);
                if (self.afterControl && !self.$repairSection.hasClass('active')) self.$repairSection.addClass('active');
                else if (!self.afterControl && self.$repairSection.hasClass('active')) self.$repairSection.removeClass('active');
            } else if ($windowWidth >= 768) {
                if (self.$repairStoreList.hasClass('slick-initialized')) self.slickEvent(self.$repairStoreList, false);
                
            }
        });

        // enter submit
        $(window).on("keyup",function(e){
            if(e.keyCode == "13"){
                if (self.$repairOrigin.is(":focus")){
                    self.$directionsForm.trigger('submit');
                } else if (self.$searchInput.is(":focus")){
                    self.$repairForm.trigger('sumbit');
                }
            }
        });

        // my address search
        self.$myAddressBtn.on('click', function(e) {
            var address = $(this).data('address');

            self.$searchInput.val(address);
            self.$repairForm.trigger('submit');

            e.preventDefault();
        });
    }

    proto.queryError = function(){
        var self = this;
        self.reset();
        self.setErrorList();
    
        self.$repairTabmenu.find("li[data-distance=" + self.distance + "]").addClass("active").siblings("li").removeClass("active");
    }
    proto.queryData = function() {
        var self = this;
        self.dataque = self.$repairForm.serialize() + "&" + $.param({
            //searchLatitudeValue: self.map.getCenter().lat,
            //searchLongitudeValue: self.map.getCenter().lng,
            //ascPostalCode: self.location.addressComponents.city,
            ascProvince: self.location.addressComponents.province,
            ascPostalCode: self.zipcode,
            ascDistance: self.distance
        });
        self.center = self.map.getCenter();
        self.$repairTabmenu.find("li[data-distance=" + self.distance + "]").addClass("active").siblings("li").removeClass("active");
        
        $('body').trigger('ajaxLoadBefore');
        $.ajax({
            url: self.options.queryUrl,
            data: xssfilter(self.dataque),
            dataType: self.options.queryType,
            error: function(xhr) {
                self.queryError();
            },
            success: function(d) {
                var data = d instanceof Array ? d : d.data;
                var dataLen = data.length;
                self.map.process = true;
                self.markers = [];
                self.stores = [];


                if (dataLen) {
                    self.reset();
                    self.$repairStoreList.parent().find('.no-items').removeClass('active');
                    
                    var searchPoint = new BMap.Point(self.geoResult.locations.lng, self.geoResult.locations.lat);
                    var compareDistance = self.options.unit == "Mile" ? self.distance*1609.344 : self.distance*1000;
                    var index = 0;
                    var newData = [];
                    
                    var setPoint = function(item){ 
                        if(dataLen == item) {
                            setMarker();
                            return;
                        }
                        if(data[item].ascLatitudeValue && data[item].ascLongitudeValue){
                            getDistanceBetween(item,data[item].ascLongitudeValue, data[item].ascLatitudeValue);
                        } else {
                            self.geocoder.getPoint(data[item]["address"], $.proxy(function(point) {
                                if(point){
                                    getDistanceBetween(item,point.lng, point.lat);
                                } else {
                                    index += 1;
                                    setPoint(index);
                                }
                            }, this));
                        }
                    }
                    var getDistanceBetween = function(item,lng,lat){
                        var pt = new BMap.Point(lng, lat);
                        var betweenDistance = (self.map.getDistance(searchPoint, pt)).toFixed(4);
                                                
                        if(compareDistance >= betweenDistance){ //asynchronous
                            data[item].pt = pt;
                            data[item].distance = betweenDistance;
                            newData.push(data[item]);
                        }
                        index+=1;
                        setPoint(index);
                    }
                    var setMarker = function(){
                    	if(newData.length){
                            var a,b;
                            for(var i=0; i<newData.length; i++){
                                a = newData[i];
                                for(var x=i+1; x<newData.length; x++){
                                    b = newData[x];
                                    if( parseInt(a.distance) > parseInt(b.distance)){
                                        newData[i] = b;
                                        newData[x] = a;
                                        a = newData[i]
                                    }   
                                }  
                            }
                            self.setRepairLists(newData);
                            $.each(newData,function(idx, data){
                                self.markerIcon.url = "/lg5-common-gp/images/customer/mark-" + (parseInt(idx, 10) + 101).toString().substr(1) + ".png";
                                self.stores.push(data);
                                var myIcon = new BMap.Icon(self.markerIcon.url, new BMap.Size(34, 46));
                                var marker = new BMap.Marker(data.pt,{icon:myIcon});

                                self.markers.push(marker);
                                self.map.addOverlay(marker);
                                (function(idx){
                                    marker.addEventListener("click",function(e){
                                        self.setStoreInfo(self.stores, self.infoBox, idx);
                                        //self.infoBox.open(markerText, data.pt);
                                        self.onItem(idx);
                                        self.focusList(idx);
                                    });
                                })(idx);
                                if (idx == 0){
                                    self.map.centerAndZoom(data.pt, 14);
                                    self.setStoreInfo(self.stores, self.infoBox, idx);
                                    self.onItem(idx);
                                    self.focusList(idx);
                                }
                                if (idx == newData.length - 1) {
                                    if ($(window).width() < 768) {
                                        self.slickEvent(self.$repairStoreList, true);
                                    }
                                    $('body').trigger('ajaxLoadEnd');
                                }
                            })
                        } else {
                            self.queryError();
                            $('body').trigger('ajaxLoadEnd');
                        }
                    }
                    setPoint(index);
                } else {
                    self.queryError();
                    $('body').trigger('ajaxLoadEnd');
                }
                self.map.process = false;
                self.$repairSection.addClass('active');
            },
            complete: function() {
                self.searchHandle = false;
            }
        })
    }


    proto.getStore = function(force) {
        var self = this;
                
        clearTimeout(self.timing.queryTimeout);
        
        self.reset();
        self.timing.queryTimeout = setTimeout($.proxy(self.queryData, self), 200);
    }

    proto.setCountry = function(address) {
        var self = this;
        self.geocoder = new BMap.Geocoder();
        
        self.geocoder.getPoint(address, $.proxy(function(point) {
            if (point) {
                self.geoResult.locations = point;
                self.center = self.map.getCenter();
                self.map.centerAndZoom(self.geoResult.locations, self.options.queryZoomLevel);
            } else {
              //  self.reset();
                self.setErrorList();
                self.afterControl = false;
            }
        }, this));
    }


    //moving map after markerk click
    proto.offsetCenter = function(latlng, offsetx, offsety, map) {
        var self = this;
        var scale = Math.pow(2, map.getZoom());
        
        var worldCoordinateCenter = latlng; //map.getProjection().fromLatLngToPoint(latlng);
        var pixelOffset = new BMap.Point((offsetx / scale) || 0, (offsety / scale) || 0);
        var worldCoordinateNewCenter = new BMap.Point(worldCoordinateCenter.lng - pixelOffset.x, worldCoordinateCenter.lat + pixelOffset.y);
        //var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
        map.panTo(worldCoordinateNewCenter);
    }

    //map infoBox panel make
    proto.setStoreInfo = function(data, self, index) {
        var data = data[index],
            content = '';
       
        content += "<div class='info-window-wrap'>";
        if(data['address'] != "") content += "<div class='repair-center-name'><a href='javascript:goProviderDetail(\"" + data['address'] + "\",\"" +  data['ascUrl'] + "\",\"" + data['ascLatitudeValue'] + "\",\"" + data['ascLongitudeValue'] + "\",\"" + data['ascPostalCode'] + "\",\"" + this.zipcode + "\",\"" + document.getElementById('repairProduct').value + "\",\"" + "" + "\",\"" + data['dmsFlag'] + "\")'><span>" + data['ascName'] + "</span></a></div>";
        if(data['address'] != "") content += "<div class='repair-address'>" + data['address'] + "</div>";
        if(data['ascPhoneNo'] != "") content += "<div class='repair-phonenumber'>" + data['ascPhoneTxt'] + " : <a href='tel:" + data['ascPhoneNo'] + "'>" + data['ascPhoneNo'] + "</a></div>";
        content += "<span class='info-window-bottom'></span>";
        content += "</div>";

        self.open(content, data.pt);
    }

    proto.searchAddress = function(e) {
        var self = this,
            address = self.$searchInput.val();

        self.geocoder = new BMap.Geocoder();
        self.geocoder.getPoint(address, $.proxy(function(point) {
            if (point) {
                self.geoResult.locations = point;
                self.center = self.map.getCenter();
                self.map.centerAndZoom(self.geoResult.locations, self.options.zoomLevel);
                self.geocoder.getLocation(self.geoResult.locations, $.proxy(function(location) {
                    self.location = location;
                    self.$resultLocation.text(address);
                    self.afterSearch();
                    self.afterControl = true;
                    
                }, this));
            } else {
                self.reset();
                self.setErrorList();
                self.afterControl = false;
            }
        }, this));

        e.preventDefault();
    };

    proto.afterSearch = function() {
        var self = this;
        self.reset();
        self.searchHandle = true;
        
        if (self.map.getZoom() < self.options.queryZoomLevel) {
            self.map.setZoom(self.options.queryZoomLevel);
        } else {
            self.distance = self.options.distance;
            self.getStore();
        }
    }

    proto.focusList = function(item, callback) {
        var self = this;
        
        if (!isMobile || $(window).width() >= 768) {
            var $list = self.$repairSection.find(".store-list");
            $list.mCustomScrollbar("scrollTo", $list.find('.mCSB_container .list-box:eq(' + item + ')'));
        }
    }

    proto.onItem = function(item) {
        var self = this;
        
        self.$repairStoreList.find(".list-box").removeClass("active").filter("[data-item='" + item + "']").addClass("active");
        
        if (typeof(self.infoBox) != "undefined") {
            if (typeof(item) == "undefined") {
                self.infoBox.close();
                self.activeItem = null;
            } else if (self.activeItem != item) {
                self.activeItem = item;
                if ($(window).width()>=768) {
                    self.offsetCenter(self.markers[item].getPosition(), 220, -100, self.map);
                } else {
                    self.offsetCenter(self.markers[item].getPosition(), 0, -140, self.map);
                }
                self.setStoreInfo(self.stores, self.infoBox, item);
            } else if (self.activeItem == item) {
                self.offsetCenter(self.markers[item].getPosition(), 220, 0, self.map);
                self.setStoreInfo(self.stores, self.infoBox, item);
            }
        }
    }

    proto.setDirectionPanel = function(e) {
        var self = this;
        e.preventDefault();

        var options = {
            renderOptions: {
                map: self.map,
                panel: "directionResultRoute",
                autoViewport: true
            },
            onSearchComplete: function(results){
                if (driving.getStatus() === 0){
                    self.$suggest.show();
                    self.$repairErrorList.hide();
                    setTimeout(function() {
                        self.$repairMapArea.find(".BMap_Marker.BMap_noprint").css(self.markerCss.origin);
                        self.$repairMapArea.find(".BMap_Marker.BMap_noprint").last().css(self.markerCss.destination);
                    },100);
                } else {
                    self.reset();
                    self.$suggest.hide();
                    self.$repairErrorList.show();
                }
            }
        }
        
        var driving = new BMap.DrivingRoute(self.map, options);
        self.geocoder.getPoint(self.$repairOrigin.val(),function(point){
            if(point){
                self.geocoder.getPoint(self.options.centerAddress, function(point2){
                    if(point2){
                        self.map.clearOverlays();
                        driving.search(point, point2);
                    } else{
                        self.reset();
                        self.$suggest.hide();
                        self.$repairErrorList.show();
                    }
                })
            } else{
                self.reset();
                self.$suggest.hide();
                self.$repairErrorList.show();
            }
        });
    }

    //query string ascPostalCode make
    proto.setRestrictionByGeocode = function(loc) {
        var self = this;
        self.geocoder.geocode({
            'location': loc
        }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                self.results = results[0].address_components;
                for (var i = self.results.length - 1; i > -1; i--) {
                    self.address = self.results[i];
                    if (self.address.types[0] == "postal_code") {
                        self.zipcode = self.address.long_name;
                        break;
                    }
                }

            }
        });
    }

    proto.setRepairLists = function(datas) {
        var self = this;
        var content = "";
        
        for(var i=0; i<datas.length; i++){
            var data = datas[i];
            
            if (typeof(data['address']) != "string") data['address'] = "";
            if (typeof(data['ascPhoneNo']) != "string") data['ascPhoneNo'] = "";

            content += "<a href='#' class='list-box list-anchor' data-item='" + i + "'>";
            content += "<div class='icon-marker store'>" + (i + 1) + "</div>";
            content += "<div class='list-text-block'>";
            content += "<div class='repair-center-name'>" + data['ascName'] + "</div>";
            content += "<div class='repair-address'>" + data['address'] + "</div>";
            if (data['ascPhoneNo'] != '' && data['ascPhoneNo'] != null) content += "<div class='repair-phonenumber'>" + data['ascPhoneTxt'] + " : <span>"+data['ascPhoneNo']+"</span></div>";
            content += "</div>";
            content += "</a>";
        }
        
        self.$repairStoreList.html(content);
    }

    proto.setErrorList = function() {
        var self = this;
        
        // if (self.$searchInput.val() != "") {
        //     var content;
        //     content = "<li class='error-list'>";
        //     content += "<div class='repair-error-list'>没有数据，请重新输入地址</div>";
        //     content += "</li>";
        //     self.$repairStoreList.html(content);
        // }

        self.$repairStoreList.parent().find('.no-items').addClass('active');
        self.$repairSection.addClass('active');
    }

    //center distance tap event
    proto.distanceHandler = function(e) {
        var self = this;
        var target = $(e.target);
        
        if (self.afterControl) {
            self.distance = target.parent().data("distance");
            self.getStore(true);
            e.preventDefault();
        }
    }

    proto.reset = function() {
        var self = this;

        if (!self.openDirection) {
            self.markers = [];
            self.map.clearOverlays();

            self.onItem();
            self.activeItem = null;

            self.$repairStoreList.html(null);
            self.$repairStoreList.parent().find('.no-7items').removeClass('active');
            self.$repairStoreList.parent().find('.btn-area').removeClass('active');

            if (self.$repairStoreList.hasClass('slick-slider') || self.$repairStoreList.hasClass('slick-initialized')) {
                self.$repairStoreList.slick('unslick');
            }
        } else {
            self.map.clearOverlays();
            self.setCountry(self.options.centerAddress);
            self.geocoder.getPoint(self.options.centerAddress, $.proxy(function (point) {
                self.map.centerAndZoom(point, 14);
                var myIcon = new BMap.Icon("/lg5-common-gp/images/customer/mark-google.png", new BMap.Size(27, 43));
                var marker = new BMap.Marker(point,{icon:myIcon});
                self.map.addOverlay(marker); // 将标注添加到地图中
            }, this));
        }        
    } 

    proto.resizing = function() {
        var self = this;

        self.center = self.map.getCenter();
        self.map.setCenter(self.center);
    }

    //mobile only map size
    proto.mapExpand = function(e) {
        var self = this;

        self.zoom = self.map.getZoom();
        
        if (!self.$repairMapArea.parent().hasClass('full')) {
            $('body').addClass('full-map');
            self.$repairMapArea.parent().addClass("full");
            self.resizing();
        } else {
            $('body').removeClass('full-map');
            self.$repairMapArea.parent().removeClass("full");
            self.resizing();
        }
        e.preventDefault();
    }

    //mobile only list paging
    proto.slickEvent = function($list, flag) {
        if (flag) {
            if (!$list.hasClass('slick-initialized')) {
                $list.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + 1;
                    $(".total-page").text(slick.slideCount);
                    $(".current-page").text(i);
                });
                $list.slick({
                    adaptiveHeight: true,
                    rows: 3,
                    slidesPerRow: 1,
                    infinite: false,
                    dots: false,
                    speed: 500,
                    prevArrow: ".pagination .prev",
                    nextArrow: ".pagination .next"
                }).next(".btn-area").addClass('active');
            } else {
                $list.slick('reInit');
            }
        } else {
            $list.off('init reInit afterChange')
            $list.slick('unslick');
        }
    }

    var layerToggleHandler = function(e) {
        var self = this,
            list = self.$repairSection;
        
        if(list.hasClass('active')) {
            list.removeClass('active');
        } else {
            list.addClass('active');
        }

        e.preventDefault();			
    }


    //"gmap" is an instance of the google map
    var baiduMap = new BaiduMaps($('.repair-service-center'));
})();
